import { render } from "./VgtPaginationPageInfo.vue?vue&type=template&id=05cb0db0"
import script from "./VgtPaginationPageInfo.vue?vue&type=script&lang=js"
export * from "./VgtPaginationPageInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__